<template>
	<div>
		<div v-for="(item, index) in fieldsArray" :key="item[index]">
			<JFlex class="s-border s-border-gray-300 s-rounded s-p-1 s-px-2 s-mb-2 s-justify-between s-items-center">
				<JFlex>
					<JText class="s-mr-2">{{ item.name ? item.name : "---" }}</JText>
				</JFlex>
				<JFlex class="s-justify-end s-items-center">
					<JText class="c7 s-mr-2">{{ item.type.kind }}</JText>
					<JInputText v-if="item.type.kind === 'LIST'" v-model="indexModifier" class="s-mr-2" />
					<JButton variant="default-sm" v-if="openedChildren !== index" @click.native="toggleShowChildren(item, index)">
						{{ $t("core.select") }}
					</JButton>
					<JButton
						variant="default-light-sm"
						type="error"
						v-if="openedChildren === index"
						@click.native="toggleHideChildren(item, index)"
					>
						{{ $t("core.deselect") }}
					</JButton>
				</JFlex>
			</JFlex>
			<FieldItem
				v-if="openedChildren === index"
				class="s-ml-4"
				:types="types"
				:fieldsArray="findTypeFields(item)"
				@path:added="handleAdd"
				@path:removed="handleRemove"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: "FieldItem",

	props: {
		fieldsArray: {
			type: Array
		},
		types: {
			type: Array
		}
	},

	data() {
		return {
			openedChildren: null,
			pathToAdd: null,
			modifiersToAdd: null,
			pathToRemove: null,
			indexModifier: 0
		}
	},

	methods: {
		findTypeFields(item) {
			const type = item?.type?.name ? item?.type?.name : item?.type?.ofType?.name
			return this.types?.find(item => item?.name === type)?.fields
		},
		toggleShowChildren(item, index) {
			this.openedChildren = index
			this.pathToAdd = item
			this.decideModifiers(item)
			this.$emit("path:added", {
				payload: this.pathToAdd,
				modifiers: this.modifiersToAdd
			})
		},
		toggleHideChildren(item) {
			this.openedChildren = null
			this.pathToRemove = item
			this.resetModifiers() // reset index modifier
			this.$emit("path:removed", {
				payload: this.pathToRemove,
				modifiers: null
			})
		},
		handleAdd({ payload, modifiers }) {
			this.pathToAdd = payload
			this.$emit("path:added", {
				payload: this.pathToAdd,
				modifiers: modifiers
			})
		},
		handleRemove({ payload, modifiers }) {
			this.pathToRemove = payload
			this.$emit("path:removed", {
				payload: this.pathToRemove,
				modifiers: modifiers
			})
		},
		decideModifiers(item) {
			if (item.type.kind === "LIST") {
				this.modifiersToAdd = { index: this.indexModifier }
			}
		},
		resetModifiers() {
			this.indexModifier = 0
			this.modifiersToAdd = null
		}
	}
}
</script>
